export function buildActivityCreateDialogFormRules({ localForm, ruleFlags, ruleValues, redRuleFlags, redRuleValues }) {
  const ACT_TYPE_LINK = 10000
  const ACT_TYPE_SIGN_IN = 4
  const ACT_TYPE_AGENT_REWARD_BOX = 6

  return {
    title: [
      {
        validator(rule, value, callback) {
          if (localForm.actType === ACT_TYPE_LINK) {
            callback()
            return
          }
          const lang = localForm.desc_lang
          const text = value && typeof value === 'object' ? value[lang] : value
          if (text == null || String(text).trim() === '') {
            callback(new Error('请输入标题'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    actType: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
    periodType: [
      {
        validator(rule, value, callback) {
          if (localForm.actType === ACT_TYPE_LINK) {
            callback()
            return
          }
          if (!value) {
            callback(new Error('请选择活动周期'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    reward_expire_days: [
      {
        validator(rule, value, callback) {
          if (localForm.actType === ACT_TYPE_LINK) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
      },
    ],
    'redRuleValues.today_bet_amount': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 2) {
            callback()
            return
          }
          if (!redRuleFlags.bet) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'redRuleValues.today_payin_amount': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 2) {
            callback()
            return
          }
          if (!redRuleFlags.payin) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'redRuleValues.countdown': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 2) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'redRuleValues.count_limit': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 2) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'redRuleValues.duration': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 2) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'redRuleValues.multiple': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 2) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    spinRuleAtLeastOne: [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 1) {
            callback()
            return
          }
          const ok = ruleFlags.login || ruleFlags.bet || ruleFlags.payin || ruleFlags.level
          if (!ok) {
            callback(new Error('请至少勾选一项规则'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    redRuleAtLeastOne: [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 2) {
            callback()
            return
          }
          const ok = redRuleFlags.bet || redRuleFlags.payin
          if (!ok) {
            callback(new Error('请至少勾选一项规则'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    'ruleValues.daily_login_bonus_count': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 1) {
            callback()
            return
          }
          if (!ruleFlags.login) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'ruleValues.daily_bet_amount': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 1) {
            callback()
            return
          }
          if (!ruleFlags.bet) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'ruleValues.daily_bet_amount_ticket_reward': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 1) {
            callback()
            return
          }
          if (!ruleFlags.bet) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'ruleValues.daily_total_payin_amount': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 1) {
            callback()
            return
          }
          if (!ruleFlags.payin) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'ruleValues.daily_total_payin_amount_ticket_reward': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 1) {
            callback()
            return
          }
          if (!ruleFlags.payin) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'ruleValues.level_up_bonus_count': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== 1) {
            callback()
            return
          }
          if (!ruleFlags.level) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) {
            callback(new Error('请输入大于0的数字'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    'signInRule.method': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== ACT_TYPE_SIGN_IN) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n !== 1) {
            callback(new Error('签到方式请选择指定天数'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    'signInRule.cycle_days': [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== ACT_TYPE_SIGN_IN) {
            callback()
            return
          }
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0 || !Number.isInteger(n)) {
            callback(new Error('请输入大于0的整数'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    url_type: [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== ACT_TYPE_LINK) {
            callback()
            return
          }
          if (value !== 'inner' && value !== 'outer') {
            callback(new Error('请选择链接类型'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    jump_url: [
      {
        validator(rule, value, callback) {
          if (localForm.actType !== ACT_TYPE_LINK) {
            callback()
            return
          }
          const text = value == null ? '' : String(value).trim()
          if (!text) {
            callback(new Error('请输入链接地址'))
            return
          }
          if (localForm.url_type === 'inner' && !text.startsWith('/')) {
            callback(new Error('站内链接必须以/开头'))
            return
          }
          if (localForm.url_type === 'outer' && !text.startsWith('http://') && !text.startsWith('https://')) {
            callback(new Error('站外链接必须以http://或https://开头'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    activityTimeRange: [
      {
        validator(rule, value, callback) {
          if (localForm.actType === ACT_TYPE_LINK) {
            callback()
            return
          }
          if (!Array.isArray(value) || value.length !== 2 || !value[0] || !value[1]) {
            callback(new Error('请选择活动时间'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    displayTimeRange: [
      {
        validator(rule, value, callback) {
          // 仅首次存款奖励（type 9）需要展示时间
          if (localForm.actType !== 9) {
            callback()
            return
          }
          if (!Array.isArray(value) || value.length !== 2 || !value[0] || !value[1]) {
            callback(new Error('请选择展示时间'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
    status: [{ required: true, message: '请选择活动状态', trigger: 'change' }],
    vips: [
      {
        validator(rule, value, callback) {
          if (localForm.actType === ACT_TYPE_LINK || localForm.actType === ACT_TYPE_AGENT_REWARD_BOX) {
            callback()
            return
          }
          if (!Array.isArray(value) || value.length < 1) {
            callback(new Error('请选择活动对象'))
            return
          }
          callback()
        },
        trigger: 'change',
      },
    ],
  }
}
